import { Body1, Box, Modal, Stack, Subtitle1 } from '@phx/design-system';
import { useTranslation } from 'react-i18next';

export const MedicineCabinetInfoModal = ({
    isOpen,
    close,
}: {
    isOpen: boolean;
    close: () => void;
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            opened={isOpen}
            onClose={close}
            title={t('cabinet.infoModal.header')}
        >
            <Stack gap="sm">
                <Box>
                    <Subtitle1>{t('cabinet.orders.verify')}</Subtitle1>
                    <Body1>{t('cabinet.infoModal.verify')}</Body1>
                </Box>
                <Box>
                    <Subtitle1>{t('cabinet.orders.fill')}</Subtitle1>
                    <Body1>{t('cabinet.infoModal.fill')}</Body1>
                </Box>
            </Stack>
        </Modal>
    );
};
